import { CrossFilledIcon, CrossIcon } from "../../Icons"
import '../index.css'

interface CloseChipProps {
  onClick?: () => void
  label?: string
  variant?: 'filled' | 'outline'
  outlineColor?: string
}

const CloseChip: React.FC<CloseChipProps> = (
  { onClick,
    label,
    variant = 'filled',
    outlineColor = '#c0bcbc'
  }) => {

  return (<>
    {(variant === "outline") && (
      <div>
        <button className="chip-btn" style={{ border: `1px solid ${outlineColor}` }} onClick={onClick}>
          <CrossFilledIcon className="chip-btn__icon" />
          {label}
        </button>
      </div>
    )}
    {(variant === "filled") && (
      <div>
        <button className="chip-btn filled" onClick={onClick}>
          <CrossIcon className="chip-btn__icon filled" />
          {label}
        </button>
      </div>
    )}
  </>)
}

export default CloseChip